import React, { useContext, useEffect, useState } from 'react'

import Container from '../../layouts/Container/Container'
import AwardsGallery from '../organisms/AwardsGallery'
import Preloader from '../atoms/Preloader'
import { StateController } from './../../App'
import BannerImage from '../molecules/BannerImage'
import ConfimDownload from '../atoms/ConfimDownload'

function Redemptions() {
  const { context } = useContext(StateController)
  const [redemtions, setRedemtions] = useState(false)
  //const segment = context?.user?.segment ? context.user.segment : '0'
  const [showConfirm, setShowConfirm] = useState(false);
  

  useEffect(() => {
    if (context && context.redemtions) {
      console.log("Context redemtions:", context)
      setRedemtions(context.redemtions)
    }
  }, [context])

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'smooth' })
  }, [])

  return (
    <div className='mc-page redemptions slow_ani'>

      <div className={`mc-page--banner ${redemtions.length === 0 ? 'empty' : ''}`}>
        <Container> 
          {
            showConfirm &&
            <ConfimDownload showConfirm={showConfirm} />
          }       
          <div className='mc-page--banner__content'>
            {redemtions && redemtions[0] &&
              <div className='mc-page--banner__content--title'>
                ¡Esta es<br/> tu  e-Gift Card!
              </div>
            }

            {/*width > 992 &&
              <div className='mc-page--banner__content--image'>
                <img src={`/assets/images/redemtinos_banner.png`} alt="" />
              </div>
            */}

            <div className={`mc-page--banner__content--items ${redemtions.length === 0 ? 'empty' : ''}`}>
              {redemtions
                ? <AwardsGallery
                  awardBoxType={2}
                  itemsPerLine={3}
                  list={redemtions}
                  showStock={false}
                  showSpecialTags={false}
                  reorder={false}
                  canRedem={true}
                  download={true}
                  redemtionText="Volver a descargar"
                  termText="Términos y condiciones"
                  termLink="/GanaConMastercardDebit/terminos-y-condiciones"
                  setShowConfirm={setShowConfirm}
                />
                : <Preloader
                  type="section"
                  invert
                />
              }
            </div>
          </div>
        </Container>
      </div>


      <div className='mc-page--extra'>

        {context && 
          <BannerImage
            textLink={'*Aplican Términos y Condiciones.'}
            link={'/GanaConMastercardDebit/terminos-y-condiciones'}
            className='container'
            textButton={'Cómo ganar'}
            linkButton={'/GanaConMastercardDebit/premio-mayor'}
          >
            <h2>
              ¿Te vas a perder Turquía? 
            </h2>
            <p>Participa por un viaje doble a Turquía y recorre Estambul, Capadocia y Ankara. Cada meta cumplida te acerca al premio mayor.</p>
          </BannerImage>
        }

      {/* {segment === '9' ? (
        <BannerImage
          textLink={'*Aplican Términos y Condiciones.'}
          link={'/GanaConMastercardDebit/terminos-y-condiciones'}
          className='container'
        >
          <h2>
            ¿Fan de los viajes y los conciertos?
          </h2>
          <p>Participa por un <b>viaje doble a São Paulo</b> y disfruta en Brasil el concierto de tu artista urbano favorito. Cada vez que logres la meta te acercas al premio mayor.</p>
        </BannerImage>
      ) : (
        <BannerImage
          textLink={'*Aplican Términos y Condiciones.'}
          link={'/GanaConMastercardDebit/terminos-y-condiciones'}
          className='container'
        >
          <h2>
            ¿Fan de los viajes y los conciertos?
          </h2>
          <p>Participa por un <b>viaje doble a São Paulo</b> y disfruta en Brasil el concierto de tu artista urbano favorito. Cada vez que logres la meta te acercas al premio mayor.</p>
        </BannerImage>
      )} */}

        
      </div>
    </div>
  )
}
export default Redemptions